import ApiFetch from 'utils/apiFetch';
import { preparePath } from 'utils/preparePath';

const SpriteInstance = ApiFetch();

export const URLS = {
  BILLING_SESSION: 'stripe/billing-portal/session',
  PAYMENT_LINK: 'stripe/payment-links',
};

export async function createBillingSession(data) {
  const path = preparePath(URLS.BILLING_SESSION, {}, data);
  return SpriteInstance.post(path);
}

export async function createPaymentLink(data) {
  const path = preparePath(URLS.PAYMENT_LINK, {}, data);
  return SpriteInstance.post(path);
}
